export enum ValidForTypes {
  Enrollment = 1,
  ExistingMember = 2,
}
